// Maps legacy "perdido" → "aplicado" on read. New writes must use "aplicado"
// directly. See Linear FRA-136 + the "Notas y caveats — Venueboard" doc for
// why this exists instead of a Firestore migration.
export const normalizeDepositoEstado = (estado) =>
  estado === "perdido" ? "aplicado" : estado;

// Desenlace de un depósito a partir de cuánto se queda el venue. Respeta la
// convención que ya leen el ledger, Cuentas y las tarjetas: "devuelto" con
// `montoDevuelto` menor al total es una resolución parcial (lo devuelto baja
// lo comprometido, el resto es ingreso); "aplicado" es quedárselo entero y
// deja `montoDevuelto` en null como los docs históricos. Todo en pesos: lo
// que no se devuelve se aplica, nunca queda dinero sin destino.
export const resolucionDeposito = (monto, montoAplicado) => {
  const total = Number(monto) || 0;
  const aplicado = Math.min(total, Math.max(0, Number(montoAplicado) || 0));
  const devuelto = total - aplicado;
  if (total <= 0) return { estado: "devuelto", montoDevuelto: 0, montoAplicado: 0 };
  if (aplicado <= 0) return { estado: "devuelto", montoDevuelto: total, montoAplicado: 0 };
  if (devuelto <= 0) return { estado: "aplicado", montoDevuelto: null, montoAplicado: total };
  return { estado: "devuelto", montoDevuelto: devuelto, montoAplicado: aplicado };
};
